import modules from '@/SidebarModules.json'

export default {
  namespaced: true,
  state: {
    moduleList: [],
    currentModuleItemName: '',
    previousFunction: ''
  },
  getters: {
    // getCurrentModuleFunction (state, getters, rootState, rootGetters) {
    //   return state.currentModule['children']
    // }
  },
  mutations: {
    setModuleList (state, sideBarCatalog) {
      state.currentModuleItemName = sideBarCatalog
      if (sideBarCatalog !== undefined)state.moduleList = modules[sideBarCatalog].catalog
    },
    setModule (state, moduleId) {
      state.moduleList.forEach(module => {
        if (module.id === moduleId) {
          module.isOpen = !module.isOpen
        }
      })
    },
    setFunction (state, functionId) {
      for (let i = 0; i < state.moduleList.length; i++) {
        for (let j = 0; j < state.moduleList[i].functions.length; j++) {
          if (state.moduleList[i].functions[j].id === functionId) {
            state.moduleList[i].functions[j].isOpen = true
          } else {
            state.moduleList[i].functions[j].isOpen = false
          }
        }
      }
    },
    setCurrentFunction (state, currentRouteName) {
      for (let i = 0; i < state.moduleList.length; i++) {
        for (let j = 0; j < state.moduleList[i].functions.length; j++) {
          if (state.moduleList[i].functions[j].routerName === currentRouteName) {
            state.moduleList[i].functions[j].isOpen = true
          } else {
            state.moduleList[i].functions[j].isOpen = false
          }
        }
      }
    }
    // setModule (state, module) {
    //   state.moduleList.forEach(moduleItem => { moduleItem.isOpen = false })

    //   state.moduleList.forEach(moduleItem => {
    //     if (moduleItem.routerName === module.routerName) {
    //       moduleItem.isOpen = true
    //     }
    //   })
    // },
    // setModuleAllClose (state) {
    //   state.moduleList.forEach(moduleItem => { moduleItem.isOpen = false })
    // },
    // setCurrentModule (state, routerName) {
    //   var currentModule = state.moduleList.find(ele =>
    //     ele.routerName === routerName
    //   )
    //   state.currentModule = currentModule
    // }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules.js